// Action types for payment reducer
export const PAYMENT_ACTIONS = Object.freeze({
  PLACE_ORDER_ERROR: 'PLACE_ORDER_ERROR',
  PLACE_ORDER_START: 'PLACE_ORDER_START',
  PLACE_ORDER_SUCCESS: 'PLACE_ORDER_SUCCESS',
  SET_PAYMENT_INSTRUMENT: 'SET_PAYMENT_INSTRUMENT'
});

// Status constants for payment state
export const PAYMENT_STATUS = Object.freeze({
  IDLE: 'idle',
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed'
});
